export default __webpack_public_path__ + "static/media/component_gas_sensor.ce21c5df.png";